/*
 * @Descripttion: 
 * @version: 
 * @Author: loong
 * @Date: 2022-09-22 17:29:43
 * @LastEditors: loong
 * @LastEditTime: 2022-10-20 11:37:11
 */
/*
* @name: 登录注册 接口地址
* @description:
* @author: KING
* @time: 2022-09-20 18:30:14
*/
import * as config from "./config"

// 登录
export const Login = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/login'
// 手机号登录
export const LoginForPhone = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/user/login'
// 注册
export const register = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/user/register'
// 忘记密码
export const forgetUpdatePwd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/user/forget/updatePwd'

